import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-152"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.986 8.36a.536.536 0 0 0-.14.02 5.372 5.372 0 0 1-1.408.189 5.596 5.596 0 0 1-1.851-.322 5.56 5.56 0 0 1-3.542-6.612A.505.505 0 0 0 7.57 1a.484.484 0 0 0-.181.036A6.204 6.204 0 0 0 3.51 7.173a5.985 5.985 0 0 0 .48 1.973 4.118 4.118 0 0 1 .967-.243 5.062 5.062 0 0 1-.448-1.79A5.212 5.212 0 0 1 6.9 2.408a6.625 6.625 0 0 0 .3 2.636 6.524 6.524 0 0 0 4.057 4.148 6.608 6.608 0 0 0 2.18.378 6.274 6.274 0 0 0 .667-.036A5.25 5.25 0 0 1 11.09 11.8a3.032 3.032 0 0 1 .354.939 6.205 6.205 0 0 0 4.022-3.706.5.5 0 0 0-.48-.671z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M8.377 11.215a2.098 2.098 0 0 0-.264.026 3.144 3.144 0 0 0-5.226 0 2.098 2.098 0 0 0-.264-.026 2.09 2.09 0 1 0 0 4.18 2.145 2.145 0 0 0 .829-.165 3.11 3.11 0 0 0 4.096 0 2.145 2.145 0 0 0 .829.166 2.09 2.09 0 1 0 0-4.18zm0 3.18a1.145 1.145 0 0 1-.443-.088 1 1 0 0 0-1.038.165 2.11 2.11 0 0 1-2.791 0 1 1 0 0 0-1.038-.165 1.145 1.145 0 0 1-.444.089 1.09 1.09 0 1 1-.006-2.18c.025 0 .05.005.076.008l.071.01a1 1 0 0 0 .956-.439 2.144 2.144 0 0 1 3.56 0 1 1 0 0 0 .956.439l.071-.01.07-.009a1.09 1.09 0 1 1 0 2.18z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }